import Hero from "../Component/Hero";
import DownloadAppSection from "../../../Components/DownloadAppSection";
import PengajuanPinjaman from "../Component/PengajuanPinjaman";
import PersyaratanPinjaman from "../Component/PersyaratanPinjaman";
import React from "react";
import CardDokumenPendukung from "../Component/CardDokumenPendukung";
import Table from "../Component/Table";

function KreditMultiGuna() {
    return (
        <>
            <div>
                <Hero
                    imageClass='kmg'
                    title='Kredit Multiguna'
                    subTitle='P I N J A M A N &emsp;I N D I V I D U'
                    explanation='
                        Kredit Multi Guna adalah kredit yang ditujukan untuk keperluan berbagai kebutuhan dari renovasi rumah sampai <em>refinancing,</em> dengan jaminan berupa tanah dan bangunan.'
                    buttonText='AJUKAN PINJAMAN'
                />
                <Table type='individu' title='kmg'/>
                <PersyaratanPinjaman type='individu'/>
                <CardDokumenPendukung type='individu'/>
                <PengajuanPinjaman type='individu'/>
                <DownloadAppSection/>
            </div>
        </>
    );
}

export default KreditMultiGuna;
